import dynamic from 'next/dynamic';
import React from 'react';
import { useMemo } from 'react';
import styles from './Purchase.module.scss';
import { PurchaseProps } from './Purchase.type';
import { PurchaseCard } from './PurchaseCard';

const SimilarPurchases = dynamic(() => import('./SimilarPurchases'), {
    ssr: false,
});

export const Purchase: React.FC<PurchaseProps> = ({
    announce,
    reference,
    activeTab,
    canPreviewAnnounce,
    tabs,
    Component,
}) => {
    const title = useMemo(
        () =>
            [
                `Извещение ${announce?.number}`,
                announce?.numberOos && ` / ${announce?.numberOos} в ЕИС`,
            ]
                .filter(Boolean)
                .join(''),
        [announce]
    );
    const announceId = announce?.id;
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>{title}</h1>
            <PurchaseCard
                activeTab={activeTab}
                announceId={announceId}
                Component={Component}
                purchase={announce}
                reference={reference}
                canPreviewAnnounce={canPreviewAnnounce}
                tabs={tabs}
            />
            {announceId && <SimilarPurchases announceId={announceId} />}
        </div>
    );
};
